<template>
  <Dialog v-model="visible" :width="600"  :min_height="180" scrollable persistent :setting="isEditStatus" @setting="$emit('setting', item.name)">
    <template slot="title">
      <span class="title">{{ sceneName }}</span>
    </template>
    <EndpointSelector v-model="selectEndpoints" :availableEndpoints="availableEndpoints" clearable multiple :label="$t('selector.endpoint')" />
    <v-form ref="form" v-model="validEditor" lazy-validation>
      <v-list-item class="px-0" v-for="(e, i) in selectEndpoints" :key="i">
        <v-list-item-avatar tile>
          <img class="imgSize" src="@/assets/icon/curtain/curtain_up_50.svg" v-if="e=='smart-button-curtain-1'" />
          <v-icon class="primary--text" v-else>{{ idToIcon[e] }}</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ config[e] ? config[e].name : $t(`type.${idToType[e]}`) }}</v-list-item-title>
          <!-- <v-list-item-subtitle>{{$t(`type.${idToType[e]}`)}}</v-list-item-subtitle> -->
        </v-list-item-content>
        <v-list-item-action  class="ml-2" :style="[idToType[e]=='FAN' ? {'width': '420px'} : {'width': '280px'}]">
          <EndpointValueSelector v-model="values[e]" :eType="idToType[e]" />
        </v-list-item-action>
      </v-list-item>
    </v-form>

    <template slot="actions">
      <v-btn color="teal" text @click="doActivate" v-if="sceneIndex!==null" :disabled="disableBtn" :loading="submittingA">{{$t('activate')}}</v-btn>
      <v-btn color="error" text @click="doDelete" v-if="sceneIndex!==null" :disabled="disableBtn" :loading="submittingD">{{$t('delete')}}</v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary" text @click="doSave" :disabled="disableBtn" :loading="submitting">{{$t('save')}}</v-btn>
    </template>
  </Dialog>
</template>

<script>
import User from '@/components/auth/User'
import BaseDialog from '@/components/utils/dialog/BaseDialog'
import Dialog from '@/components/utils/dialog/Dialog'
import EndpointSelector from '@/components/utils/select/EndpointSelector'
import EndpointValueSelector from '@/components/utils/select/EndpointValueSelector'

export default {
  name: 'ScenceDialog',
  mixins: [BaseDialog, User],
  components: {
    Dialog,
    EndpointSelector,
    EndpointValueSelector
  },
  props: {
    pie: {
      type: String,
      required: true
    },
    item: {
      type: Object
    },
    sceneIndex: {
      type: Number
    },
    scenes: {
      Object
    }
  },
  data() {
    return {
      values: {},
      validEditor: false,
      submitting: false,
      submittingA: false,
      submittingD: false,
      selectEndpoints: [],
      idToType: {
        "onboard-main-light": "LIGHT", 
        "external-light-1": "LIGHT", 
        "onboard-main-fan": "FAN", 
        "smart-button-curtain-1": "CURTAIN", 
        "onboard-sensor-temperature": "TEMPERATURE", 
        "onboard-sensor-humidity": "HUMIDITY", 
        "onboard-sensor-illumination": "ILLUMINATION", 
        "onboard-air-sensor-co2": "CONCENTRATION", 
        "onboard-air-sensor-co": "CONCENTRATION", 
        "onboard-air-sensor-voc": "CONCENTRATION", 
        "onboard-sensor-motion": "MOTION", 
        "onboard-sensor-smoke": "SMOKE", 
        "smart-button-3": "BUTTON", 
        "smart-relay-4": "SWITCH"
      },
      idToIcon: {
        "onboard-main-light": 'mdi-lightbulb', 
        "external-light-1": 'mdi-lightbulb', 
        "onboard-main-fan": 'mdi-fan', 
        "smart-button-curtain-1": "mdi-window-shutter-open", 
        "onboard-sensor-temperature": "mdi-thermometer", 
        "onboard-sensor-humidity": "mdi-water", 
        "onboard-sensor-illumination": "mdi-brightness-6", 
        "onboard-sensor-motion": "mdi-motion-sensor", 
        "onboard-sensor-smoke": "mdi-smoke-detector", 
        "smart-button-3": "mdi-gesture-tap", 
        "smart-relay-4": "mdi-toggle-switch"
      }
    }
  },
  computed: {
    info() {
      return (this.userDevice[this.pie] || {}).info || {};
    },
    config() {
      return (this.userDevice[this.pie] || {}).config || {};
    },
    availableEndpoints() {
      return this.info.map(i => i.id);
    },
    endpoints() {
      return this.item.action.map(a => {
        let tempObj = Object.entries(a).filter(e => e[1] !== -1);
        return Object.fromEntries(tempObj);
      })
    },
    sceneName() {
      return  this.item ? ((this.config || {})[this.item.name] || {}).name || this.item.name : this.$t('scene.add_scene');
    },
    isEditStatus() {
      return this.sceneIndex !== null;
    },
    canSave() {
      return this.validEditor;
    },
    disableBtn() {
      return !this.canSave || this.submitting || this.submittingA || this.submittingD;
    }
  },
  methods: {
    async doSave() {
      this.submitting = true;
      let action = this.selectEndpoints.map(e => {
        return {id: e, ...this.values[e]}
      });
      if (this.isEditStatus) {
        //Edit scene
        this.scenes[this.sceneIndex] = {
          name: this.item.name,
          action: action
        };
      } else {
        //Add scene
        let sl = this.scenes.length;
        let list10 = [...Array(10).keys()].map(x => x + 1);
        let snl = this.scenes.map(s => parseInt(s.name.split('-')[1]));
        let diff = list10.filter(x => !snl.includes(x));
        this.scenes[sl] = {
          name: 'scene-' + JSON.stringify(Math.min(...diff)),
          action: action
        };
      }
      let cmd = {
        version: 1,
        agent: {
          id: this.userId
        },
        device: {
          id: this.pie
        },
        timestamp: new Date().getTime(),
        payload: {
          sceneList: this.scenes
        }
      };
      if (action.length != 0) {
        await this.doCommand(cmd, 'scene/set');
        this.$emit('toast', this.$t('scene.send_successfully'));
        this.submitting = false;
        this.visible = false;
      } else {
        this.$emit('toast', this.$t('scene.no_selected_endpoint'));
        this.submitting = false;
      }
    },
    async doActivate() {
      this.submittingA = true;
      let cmd = {
          version: 1,
          timestamp: new Date().getTime(),
          device: {
              id: this.pie
          },
          agent: {
            id: this.userId
          },
          scenes: {
            [this.item.name]: {
              deactivate: false
            }
          }
      };
      await this.doCommand(cmd, 'scene/command');
      this.$emit('toast', this.$t('scene.activate'));
      this.submittingA = false;
      this.visible = false;
    },
    async doDelete() {
      this.submittingD = true;
      this.scenes.splice(this.sceneIndex, 1);
      let cmd = {
        version: 1,
        agent: {
          id: this.userId
        },
        device: {
          id: this.pie
        },
        timestamp: new Date().getTime(),
        payload: {
          sceneList: this.scenes
        }
      };
      await this.doCommand(cmd, 'scene/set');
      this.$emit('toast', this.$t('scene.delete'));
      this.submittingD = false;
      this.visible = false;
    }
  },
  mounted() {
    if (this.item && this.item.action) {
      this.item.action.map(a => {
          let tempObj = Object.entries(a).filter(e => e[1] !== -1);
          return Object.fromEntries(tempObj);
      }).forEach(i => {
        this.selectEndpoints.push(i.id);
        let tempObj = {};
        if (i.on) tempObj.on = i.on;
        if (i.brightness) tempObj.brightness = i.brightness;
        if (i.openDirection) tempObj.openDirection = i.openDirection;
        if (i.openPercent) tempObj.openPercent = i.openPercent;
        if (i.fanDirection) tempObj.fanDirection = i.fanDirection;
        if (i.fanSpeed) tempObj.fanSpeed = i.fanSpeed;
        this.values[i.id] = tempObj;
      });
    }
  }
}
</script>
<style scoped>
.imgSize {
  width: 20px;
  height: 20px;
}
</style>